import * as ErrorHandler from 'common/ErrorHandler';
import { Api, SecureApi, WebApi } from 'common/http';

import type { IConfig, IUserConfig } from 'types';

export async function getConfigFromWebApi(): Promise<IConfig> {
  try {
    const { data } = await WebApi.get('/config');
    return data;
  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting config from cache');
  }
}

export async function getConfig(): Promise<IConfig> {
  try {
    const { data } = await Api.get('/text-mappings/RO_ro');
    return data;
  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting config from backend');
  }
}

export async function getUserConfig(): Promise<IUserConfig> {
  try {
    const { data } = await SecureApi.get('/user-config/ro_RO');
    return data;
  } catch (err) {
    ErrorHandler.throwError(err, 'Error while getting user config');
  }
}
